import useApi, { ApiOptions } from '../base/useApi';
interface Params {
  key: string;
}

interface Result {}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/user/resend_link',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useResendUserLink = (params?: Params) => {
  options.lazy = false;
  return useApi<Params, Result>(options, params);
};

export const useResendUserLinkLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useResendUserLink;
